export const waitFor = (test, callback, attempts = 10, attemptInterval = 100) => {
    let doneAttempts = 0;
    const timer = setInterval(() => {
        const testResolved = test();
        const attemptsResolved = doneAttempts >= attempts;
        if (testResolved || attemptsResolved) {
            clearInterval(timer);
            callback(testResolved);
        }
        doneAttempts++;
    }, attemptInterval);
    // Return stop function that clean interval
    return () => {
        clearInterval(timer);
    };
};
export default waitFor;
//# sourceMappingURL=waitFor.js.map